import growthAcquisitionExperiments from 'bundles/epic/clients/GrowthAcquisition';

export const isRestrictedEnterpriseUser = (thirdPartyOrganizationIds: string[]) =>
  thirdPartyOrganizationIds.some((thirdPartyOrganizationId) => {
    return growthAcquisitionExperiments
      .preview('marketingConsentModalRestrictedEnterprises')
      .includes(thirdPartyOrganizationId);
  });
